import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#003d4d',
      light: '#0a4d5f',
      dark: '#002833',
    },
    secondary: {
      main: '#ff8f00',
      light: '#ffa040',
      dark: '#c56000',
    },
    text: {
      primary: '#0A2533',
      secondary: '#546E7A',
    }
  },
  typography: {
    h1: {
      fontSize: '4.5rem',
      fontWeight: 700,
      color: '#0A2533',
    },
    h2: {
      fontSize: '2.5rem',
      fontWeight: 600,
      color: '#0A2533',
    },
    h3: {
      fontSize: '1.5rem',
      fontWeight: 600,
      color: '#0A2533',
    },
    body1: {
      fontSize: '1.125rem',
      color: '#546E7A',
    }
  }
});